import {Injectable, NgZone} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ErrorNotificationService {

  constructor(public snackBar: MatSnackBar, private _ngZone: NgZone) { }

  notifyTechnicalError(errorId: string) {
    const message = errorId !== '-1' ? `Erreur technique (identifiant : ${errorId})` : 'Erreur technique';
    this.notify(message);
  }

  notify(message: string) {
    this._ngZone.run(() => {
      setTimeout(() => {
        this.snackBar.open(message, 'OK', {
          duration: 10000
        });
      });
    });
  }
}
